import { Table, Tag } from "antd";
import moment from "moment";
import { useNavigate } from "react-router-dom";

function BidList({ bidList, loader }) {
  const navigate = useNavigate();

  const handleDetailedView = (bid) => {
    console.log(bid);
    navigate("/bid-detailed-view", { state:  bid  });
  };
  const getStatusColor = (status) => {
    const statusColors = {
      live: "green",
      sheduled: "gold",
      approved: "blue",
      expired: "red",
    };
    return statusColors[status] || "default";
  };
  const column = [
    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Sl.No</span>
      ),
      dataIndex: "_id",
      render: (text, record, index) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {index + 1}
        </span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Name</span>
      ),
      dataIndex: "productName",
      render: (productName) => (
        <div className="font-medium">{productName}</div>
      ),

    },

    {
      title: "Category Details",
      key: "categoryDetails",
      render: (_, record) => (
        <div>
          <div className="font-medium">{record.category.name}</div>
          <div className="text-gray-500">{record.subCategory.name}</div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={getStatusColor(status)}>{status.toUpperCase()}</Tag>
      ),
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">
          Date & Time
        </span>
      ),
      dataIndex: "createdDate",
      render: (createDate) => (
        <span className="text-[#878787] text-[16px] font-medium">
          {moment(createDate).format("DD/MM/YYYY HH:mm")}
        </span>
      ),
      align: "center",
    },

    {
      title: (
        <span className="text-[#4A4A4C] text-[14px] font-mediums">Actions</span>
      ),
      dataIndex: "status._id",
      align: "center",
      render: (text, record) => (
        <>
          <div className="gap-2 flex justify-center">
            <button
              className="cursor-pointer bg-[#1955EB] font-semibold text-[16px] px-3 text-white rounded-md  py-2 mr-2"
              onClick={() => handleDetailedView(record._id)}
            >
              View Detail
            </button>
          </div>
        </>
      ),

    },
  ];

  return (
    <div className="container">
      <div className="shadow-lg hover:shadow-xl rounded-xl mt-4 overflow-x-auto">
        <Table
          className="min-w-full divide-y divide-gray-200"
          //   pagination={{
          //     total: myBids?.length,
          //     showTotal: (total, range) =>
          //       `Showing ${range[0]} to ${range[1]} of ${total} entries`,
          //     showSizeChanger: true,
          //     onShowSizeChange: onShowSizeChange,
          //     itemRender: itemRender,
          //   }}
          columns={column}
          loading={loader}
          dataSource={bidList}
          rowKey={(record) => record._id}
          
        />
      </div>
    </div>
  );
}

export default BidList;
